import { render, staticRenderFns } from "./JeecgTreeTable.vue?vue&type=template&id=2090c591&scoped=true"
import script from "./JeecgTreeTable.vue?vue&type=script&lang=js"
export * from "./JeecgTreeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2090c591",
  null
  
)

export default component.exports